import {useMutation} from "@tanstack/react-query";
import {reportMedia} from "../api/public-voissa/medias";
import {reportArticle} from "../api/public-voissa/articles";
import {reportUser} from "../api/public-voissa/users";
import {reportAlbum} from "../api/public-voissa/albums";
import {reportStory} from "../api/public-voissa/stories";
import {reportComment, reportSubComment} from "../api/public-voissa/comments";
import {reportTopic} from "../api/public-voissa/topics";
import {reportForumComment} from "../api/public-voissa/forums";


const REPORT_KINDS = {
    PROFILE : "profile",
    ALBUM : "albums",
    MEDIA : "medias",
    STATUS : "status",
    ARTICLE : "articles",
    STORY : "stories",
    TOPIC : "topics",
    TOPIC_COMMENT : "topic_comments",
    COMMENT : "comments",
    SUB_COMMENT : "sub_comments"
}

const useReport = ({
         parentKind  = "",
         parentId,
         commentKindParent,
         commentId,
         subCommentId,
         onSuccess = () =>{},
         onMutate = () =>{},
         onError = () =>{}
     }) =>{


    async function handleSuccess (){
        onSuccess();
    }

    function handleError (){
        onError();
    }

    const getMutation = (message) =>{
        const _parentKind = parentKind?.toLowerCase();
        const _commentKindParent = commentKindParent?.toLowerCase();
        switch (_parentKind) {
            case REPORT_KINDS.PROFILE:
                return reportUser(parentId, {message});
            case REPORT_KINDS.ALBUM:
                return reportAlbum(parentId, {message});
            case REPORT_KINDS.MEDIA:
                return reportMedia(parentId, {message});
            case REPORT_KINDS.ARTICLE:
                return reportArticle(parentId, {message});
            case REPORT_KINDS.STORY:
                return reportStory(parentId, {message});
            case REPORT_KINDS.TOPIC:
                return reportTopic(parentId, {message});
            case REPORT_KINDS.TOPIC_COMMENT:
                return reportForumComment(parentId, commentId, subCommentId, {message});
            case REPORT_KINDS.COMMENT:
                return reportComment(_commentKindParent, parentId, commentId, {message});
            case REPORT_KINDS.SUB_COMMENT:
                return reportSubComment(_commentKindParent, parentId, commentId, subCommentId, {message});
            default:
                return null;
        }
    }

    const {
        mutate, isLoading
    } = useMutation(getMutation,{
        onSuccess: handleSuccess,
        onError: handleError
    });

    function handleReport(message) {
        if(!isLoading){
            mutate(message);
            onMutate();
        }
    }

    return {handleReport};
}

export default useReport;
export {REPORT_KINDS};